<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        style="
          border-radius: 50px;
          height: 25px;
          width: 25px;
          border: #ddd 1px solid;
          cursor: pointer;
        "
        :style="{ backgroundColor: colorCode }"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <v-card style="background-color: #f9f9f9">
      <v-card-actions style="background-color: #f9f9f9">
        <v-color-picker
          v-model="editColorCode"
          class="ma-2"
          :swatches="swatches"
          show-swatches
          hide-inputs
          :width="300"
          :canvas-height="80"
          @update:color="changeColorCode"
          style="background-color: #f9f9f9"
        />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ColorPickerMenu',
  props: {
    colorCode: {
      type: String,
      default: '#FFFFFF'
    }
  },
  data () {
    return {
      editColorCode: this.colorCode,
      menu: false,
      swatches: [
        ['#FFFFFF', '#AAAAAA', '#000000'],
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055']
      ]
    }
  },
  watch: {
    colorCode () {
      if (!this.colorCode || !this.isColorHex(this.colorCode)) return
      this.editColorCode = this.colorCode
    }
  },
  methods: {
    changeColorCode (value) {
      this.$emit('change-color-code', value.hex)
    },
    isColorHex (value) {
      return value.match(/^#([0-9a-fA-F]{6})$/) != null
    }
  }
}
</script>
